"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _interalExternalArrows = require("../../utils/interalExternalArrows");
var _Video = _interopRequireDefault(require("../Video/Video"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const renderGatsbyLinkOrAnchorTag = (contentfulId, linkText, destination, theme, mouse, icon, external, Link, video, override, setOverride, setVisible, onClick) => {
  if (override) {
    setVisible(true);
  }
  if (video) {
    video.setVisible = setVisible;
  }
  return /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    contentfulId: contentfulId,
    tabIndex: mouse ? "" : "0",
    className: theme?.color?.toLowerCase() !== "#ffffff" ? `luna-link__link` : `luna-link__link luna-link__dark-theme-link`,
    to: destination ? destination : null,
    style: {
      color: theme?.color || "#252A2E"
    },
    Link: Link,
    VideoComponent: _Video.default ? _Video.default : null,
    setOverride: setOverride ? setOverride : null,
    override: override ? override : null,
    children: linkText,
    video: video ? video : null,
    onClick: onClick
  });
};
const SingleLink = _ref => {
  let {
    contentfulId,
    linkText,
    destination,
    theme,
    mouse,
    icon,
    external,
    Link,
    video,
    setVisible,
    onClick
  } = _ref;
  const [override, setOverride] = (0, _react.useState)(false);
  if (!destination && !onClick && !video) {
    return;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `luna-link`
  }, renderGatsbyLinkOrAnchorTag(contentfulId, linkText, destination, theme, mouse, icon, external, Link, video, override, setOverride, setVisible, onClick), icon && external && (0, _interalExternalArrows.arrowDiagonalRight)(theme?.color), icon && !external && (0, _interalExternalArrows.arrowRight)(theme?.color));
};
exports.SingleLink = SingleLink;